import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getMaps } from "../../../features/creator/creatorSlice";

export const useMapFromSearchParams = () => {
    const dispatch = useDispatch();
    const { maps } = useSelector((state) => state.creator);

    const [searchParams] = useSearchParams();
    const mapId = searchParams.get("mapId");

    const [mapBeingHandled, setMapBeingHandled] = useState(null);

    useEffect(() => {
        dispatch(getMaps());
    }, []);

    useEffect(() => {
        const map = maps.find((map) => map._id === mapId);

        if (map) {
            setMapBeingHandled(map);
        }
    }, [maps]);

    const [toDisplay, setToDisplay] = useState(false); // Indicates map is ready to be rendered

    useEffect(() => {
        if (mapBeingHandled) {
            setToDisplay(true);
        }
    }, [mapBeingHandled]);

    return { mapBeingHandled, toDisplay };
};